<template>
  <div>
    <section class="xbed-sub-title">
      <span>调整单列表</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>调整单列表</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Form :model="inquireList" :label-width="90" inline>
      <div style="display:block">
        <FormItem label="创建日期">
          <DatePicker v-model="inquireList.date" format="yyyy年MM月dd日" type="daterange" placement="bottom-end" placeholder="" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="审批状态">
          <Select v-model="inquireList.audit" class="select-style">
            <Option :value="0">全部</Option>
            <Option :value="1">待复核</Option>
            <Option :value="2">待审批</Option>
            <Option :value="3">审批通过</Option>
            <Option :value="4">已取消</Option>
          </Select>
        </FormItem>
        <FormItem label="调整单号">
          <Input v-model="inquireList.adjustmentResultId" placeholder=""></Input>
        </FormItem>
      </div>
      <div style="display:block">
        <FormItem label="订单号">
          <Input v-model="inquireList.orderNo" placeholder=""></Input>
        </FormItem>
        <FormItem label="入住单号">
          <Input v-model="inquireList.checkinId" placeholder=""></Input>
        </FormItem>
        <FormItem label="子入住单号">
          <Input v-model="inquireList.checkinInfoId" placeholder=""></Input>
        </FormItem>
      </div>
      <div style="display:block">
        <FormItem :label-width="30">
          <Button type="primary" @click="inquireBtn">查询</Button>
        </FormItem>
        <FormItem :label-width="30">
          <Button type="primary" @click="addAdjustSheet">新增调整单</Button>
        </FormItem>
      </div>
      
    </Form>
    <!-- 表格 -->
    <Table stripe :columns="adjustSheetInfo" :loading="loading" :data="adjustSheetListData"></Table>
    <div>
      <Page show-sizer placement="top" :total="totalCount" :page-size="pageSize" :current="currentPage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <!-- 复核弹窗 -->
    <Modal v-model="reviewModal.display" :title="reviewModal.audit === 2?'调整单审批':'调整单复核'" :loading="modalLoading" @on-ok="submitBtn" ok-text="提交">
      <Form :label-width="80" :model="reviewModal">
        <FormItem label="调整单号">
          <span>{{reviewModal.adjustmentResultId}}</span>
        </FormItem>
        <FormItem label="审批状态">
          <Select v-show="reviewModal.audit===2" v-model="reviewModal.reviewState" class="select-style">
            <Option :value="2">审批通过</Option>
            <Option :value="3">取消(不通过)</Option>
          </Select>
          <Select v-show="reviewModal.audit===1" v-model="reviewModal.reviewState" class="select-style">
            <Option :value="2">复核通过</Option>
            <Option :value="3">取消(不通过)</Option>
          </Select>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="reviewModal.reviewNote" type ="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="500" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import Utils from "@/utils";
import API from "@/api";
import moment from "moment";
import {STORE_KEY} from "../../constants";
export default {
  created() {
      this.token = Utils.findFromLocalStorage("vue-token");
      this.env = Utils.findFromLocalStorage("env", "dev");
      this.username = Utils.findFromLocalStorage("vue-username");
    },
  mounted(){
     this.$Notice.config({
      top: 200
    });
    this.queryAdjustSheetList()
  },
  data(){
    return {
      loading:false,
      reviewAuditText:['','复核通过','审批通过'],
      modalLoading:false,
      reviewModal:{
        display:false,
        reviewState:2,
        reviewNote:''
      },
      inquireList:{
        date: [],
        audit:0,
        adjustmentResultId:null,
        orderNo:null,
        checkinId:null,
        checkinInfoId:null,
      },
      pageSize:10,//每页行数
      totalCount:0,//总数
      currentPage:1,//当前页数
      page:1,
      // 表格数据声明
      adjustSheetInfo:[
        {
          title: '调整单号',
          key: 'adjustmentResultId',
          align:'center',
          width: 100
        },
        {
          title: '审批状态',
          key: 'audit',
          align:'center',
          width: 100,
          render:(h,params) => {
            const statusText = ['', '待复核', '待审批', '审批通过','已取消'][params.row.audit]
            return h('div', {}, statusText)
          }
        },
        {
          title: '审批时间',
          key: 'approverDate',
          align:'center',
          width: 100
        },
        {
          title: '操作',
          key: 'name',
          align:'center',
          width: 130,
          render: (h, params) => {
              return h('div', [
                  h('Button', {
                    props: {
                      // type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px',
                    },
                    on: {
                      click: () => {
                        if (!this.checkHasPermission('oms_adjustment_details')) {
                         return;
                        }
                         if (this.$router) {
                          this.$router.push({
                            path: "/app/Order/adjustment/adjustmentDetail",
                            query: { 
                              adjustmentResultId: params.row.adjustmentResultId,
                              audit:params.row.audit
                            }
                          });
                        }else{
                          window.open(`#/Order/adjustment/adjustmentDetail?adjustmentResultId=${params.row.adjustmentResultId}&audit=${params.row.audit}`);
                        }
                      }
                    }
                  }, '详情'),
                  h(params.row.audit !== 4 && params.row.audit !== 3 ?'Button':'', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                  on: {
                    click: () => {
                      this.checkStatusBtn({
                        audit:params.row.audit,
                        adjustmentResultId:params.row.adjustmentResultId
                      })
                    }
                  }
                }, 
                params.row.audit === 1 ?'复核 ':'审批')
              ]);
          }
        },
        {
          title: '订单号',
          key: 'orderNo',
          align:'center',
          width: 100
        },
        {
          title: '入住单号',
          key: 'checkinId',
          align:'center',
          width: 100
        },
        {
          title: '子入住单号',
          key: 'checkinInfoId',
          align:'center',
          width: 120
        },
        {
          title: '实际开始结束日期',
          align:'center',
          width: 350,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原日期: ${params.row.orgActualCheckinTime!==null?moment(params.row.orgActualCheckinTime).format('YYYY年MM月DD日'):''}-${params.row.orgActualCheckoutTime?moment(params.row.orgActualCheckoutTime).format('YYYY年MM月DD日'):''}`),
              h('p',{},`调整: ${params.row.actualCheckinTime!==null?moment(params.row.actualCheckinTime).format('YYYY年MM月DD日'):''}-${params.row.actualCheckoutTime?moment(params.row.actualCheckoutTime).format('YYYY年MM月DD日'):''}`)              
              ])
          }
        },
        {
          title: '房费原价',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgRoomPrice/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.roomPrice/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.roomPriceDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '业主优惠',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgOwnerBear/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.ownerBear/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.ownerBearDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: 'Xbed优惠',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgXbedBear/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.xbedBear/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.xbedBearDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '应付',
          key: 'address',
          align:'center',
          width: 150,
           render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgShouldPay/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.shouldPay/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.shouldPayDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: 'OTA佣金',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgChannelCommission/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.channelCommission/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.channelCommissionDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '渠道活动费',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgOtherChannelExpenses/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.otherChannelExpenses/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.otherChannelExpensesDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '业主推广费',
          align:'center',
          width: 150,
           render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgOwnerPromotionExpense/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.ownerPromotionExpense/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.ownerPromotionExpenseDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: 'Xbed推广费',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgXbedPromotionExpense/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.xbedPromotionExpense/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.xbedPromotionExpenseDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: 'Xbed实收',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgReceivedPrice/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.receivedPrice/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.receivedPriceDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '结算房费',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgSettlementPrice/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.settlementPrice/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.settlementPriceDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '平台服务费',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgPlatformPrice/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.platformPrice/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.platformPriceDiff/100).toFixed(2)}`)              
              ])
          }
        },
        {
          title: '推广费返利',
          align:'center',
          width: 150,
          render:(h, params) => {
            return ('div',[
              h('p',{},`原额: ${(params.row.orgPromotionExpenseBack/100).toFixed(2)}`),
              h('p',{},`调整额: ${(params.row.promotionExpenseBack/100).toFixed(2)}`),
              h('p',{},`差额: ${(params.row.promotionExpenseBackDiff/100).toFixed(2)}`)              
              ])
          }
        }
      ],
      adjustSheetListData:[
      //  {
      //   adjustmentResultId:11,
      //   audit:3
      //  }
      ]
    }
  },
  methods:{
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    async queryAdjustSheetList(){
      this.loading = true;
      let params = {
       adjustmentResultId:this.inquireList.adjustmentResultId||'',
       audit:this.inquireList.audit||'',
       checkinId:this.inquireList.checkinId||'',
       checkinInfoId:this.inquireList.checkinInfoId||'',
       createEnd:this.inquireList.date[1]?moment(this.inquireList.date[1]).format("YYYY-MM-DD"):'',
       createStart:this.inquireList.date[0]?moment(this.inquireList.date[0]).format("YYYY-MM-DD"):'',
       orderNo:this.inquireList.orderNo||'',
       page:this.currentPage,
       size:this.pageSize
      }
      const resp = (await API.omsAPI[this.env].order.getAdjustmentList(
        params,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取调整单列表失败',
          desc: resp.msg
        })
        return
      } else {
        this.adjustSheetListData = resp.content
        this.totalCount = resp.total
        this.loading = false
        }
    },
    //查询
    inquireBtn(){
      this.currentPage = 1
      this.queryAdjustSheetList()
    },
    //新增调整单
    addAdjustSheet(){
      if (!this.checkHasPermission('oms_adjustment_insert')) {
        return;
        }
      if(this.$router){
        this.$router.push({ path: "/app/Order/adjustment/addAdjustsheet"})
      } else {
        window.open(`#/Order/adjustment/addAdjustsheet`);
      }
      
    },
    async submitBtn(){
      if(this.reviewModal.audit === 1){
         if (!this.checkHasPermission('oms_adjustment_review')) {
          return;
         }
        const params ={
          adjustmentResultId:this.reviewModal.adjustmentResultId,
          operator:this.username,
          reviewNote:this.reviewModal.reviewNote||'',
          reviewState:this.reviewModal.reviewState
        }
        const resp = (await API.omsAPI[this.env].order.getAdjustmentReview(
        params,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '复核失败',
          desc: resp.msg
        })
        return
      } else {
        this.$Notice.success({
          title: '复核成功'
        })
        this.queryAdjustSheetList()
        }
      } 
      if(this.reviewModal.audit === 2) {
         if (!this.checkHasPermission('oms_adjustment_approval')) {
          return;
          }
        const secondParams = {
          adjustmentResultId:this.reviewModal.adjustmentResultId,
          approvalNote:this.reviewModal.reviewNote||'',
          approvalState:this.reviewModal.reviewState,
          operator:this.username,
        }
        const resp = (await API.omsAPI[this.env].order.getAdjustmentApproval(
        secondParams,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '审批失败',
          desc: resp.msg
        })
        return
      } else {
        this.$Notice.success({
          title: '审批成功',
          desc: resp.msg
        })
        this.queryAdjustSheetList()
        }
      }
    },
    //表格中审核按钮
    checkStatusBtn(review = {}){
      this.reviewModal = Object.assign(this.reviewModal,{
        display:true
      },
      review)      
    },
    // 改变每页行数
    changePageSize(pageSize){
      this.currentPage = 1
      this.pageSize = pageSize
      this.queryAdjustSheetList()
    },
    // 改变当前页数
    changePage(page){
      this.currentPage = page
      this.queryAdjustSheetList()
    }
  }
}
</script>
<style lang="scss" scoped>
  .select-style{
    width: 150px;
  }
</style>





// WEBPACK FOOTER //
// src/pages/adjustment-sheet/adjustment-list.vue